import dotenv from 'dotenv';
dotenv.config();

export default Object.freeze({
  ...(process.env)
});